import React, { ReactElement } from 'react';
import FormSelector from 'adapter/in/common/components/Selector';
import {
    getErrorMessage,
    hasErrorFormSelector,
    onChangeSelect,
    onChangeSelectAll,
    SelectorContainerProps,
} from 'adapter/in/common/form/Selector';
import { SelectorOption, SelectorType } from 'adapter/in/common/form/types';
import { useBaseSelectorContainer } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import { useBaseDefaultValuesSelector } from 'adapter/in/common/hooks/form/useBaseDefaultValuesSelector';
import i18n from 'asset/translation';

type DefaultValuesSelectorContainerProps = SelectorContainerProps & {
    parseOptions?: (opts: SelectorOption[] | undefined) => SelectorOption[];
    style?: React.CSSProperties;
};

export const DefaultValuesSelectorContainer = ({
    name,
    label,
    configType,
    dataDependsOn,
    affectsTo,
    disabled,
    properties,
    parseOptions,
    style,
    footer,
}: DefaultValuesSelectorContainerProps): ReactElement => {
    const { value, onChange, invalid, error, shouldLoad } = useBaseSelectorContainer(name, {}, undefined, dataDependsOn, affectsTo);
    const defaultValues = properties?.defaultValues ? properties?.defaultValues : [];
    const { isLoading, maxSelectionLength, minSelectionLength, options } = useBaseDefaultValuesSelector<SelectorOption>(
        SelectorType.SELECT,
        configType,
        value,
        shouldLoad,
        defaultValues,
        onChange
    );
    const optionsAvailable = parseOptions ? parseOptions(options) : options;
    return (
        <FormSelector
            style={style}
            disabled={disabled}
            error={hasErrorFormSelector(invalid, error, options)}
            errorMessage={value ? getErrorMessage(value.value, minSelectionLength, maxSelectionLength) : ''}
            handleButtonSelectAll={(values: string[]) => onChangeSelectAll(configType)(values, onChange)}
            handleClearAll={() => console.log('clear all')}
            isLoading={isLoading}
            label={label}
            maxSelectionLength={maxSelectionLength}
            minSelectionLength={minSelectionLength}
            name={name}
            onChange={(selectedValue: string | string[]) =>
                onChangeSelect(minSelectionLength, maxSelectionLength, configType, value)(selectedValue, onChange)
            }
            onClear={() => onChangeSelect(minSelectionLength, maxSelectionLength, configType, value)([], onChange)}
            options={optionsAvailable}
            placeholder={
                minSelectionLength === 0 ? i18n.t('common.selector.placeholder.optional') : i18n.t('common.selector.placeholder.required')
            }
            value={value?.value}
            footer={footer}
        />
    );
};
